import { t as __exportAll } from "../rolldown-runtime-CNktS9qV.mjs";
import axios from "axios";
import { stringify } from "qs";
//#region src/listing-persister/client.ts
const axiosInstance = axios.create({ paramsSerializer: { serialize: (params) => stringify(params, { arrayFormat: "repeat" }) } });
function initHTTPClient(baseURL, onRequest, onRejectedResponse) {
	axiosInstance.defaults.baseURL = baseURL;
	if (onRequest) axiosInstance.interceptors.request.use(onRequest);
	if (onRejectedResponse) axiosInstance.interceptors.response.use((response) => response, onRejectedResponse);
	return axiosInstance;
}
const axiosClient = async (config) => {
	return axiosInstance.request({ ...config }).catch((e) => {
		throw e;
	});
};
//#endregion
//#region src/listing-persister/gen/models/ViewInvoices.ts
const ViewInvoicesInvoiceType = {
	Normal: "Normal",
	PaymentReminder: "PaymentReminder",
	CreditNote: "CreditNote",
	RenovationGuarantee: "RenovationGuarantee",
	RecurrentPayment: "RecurrentPayment",
	MasterTemplate: "MasterTemplate",
	Other: "Other"
};
const ViewInvoicesState = {
	New: "New",
	Assigned: "Assigned",
	WaitingForAuthorization: "WaitingForAuthorization",
	ManualReview: "ManualReview",
	Approved: "Approved",
	ReadyForPayment: "ReadyForPayment",
	FailedToExport: "FailedToExport",
	Paid: "Paid",
	PartiallyPaid: "PartiallyPaid",
	ManuallyPaid: "ManuallyPaid",
	ReadyForDrawdown: "ReadyForDrawdown",
	DrawdownCompleted: "DrawdownCompleted",
	InDispute: "InDispute",
	Rejected: "Rejected",
	Reimbursed: "Reimbursed",
	Duplicated: "Duplicated",
	ReadyForBooking: "ReadyForBooking",
	Authorized: "Authorized",
	WaitingForDrawdown: "WaitingForDrawdown",
	WaitingForExternalReview: "WaitingForExternalReview"
};
const ViewInvoicesCostType = {
	Notary: "Notary",
	LandTransferTaxes: "LandTransferTaxes",
	AgencyFee: "AgencyFee",
	PropertyRegistration: "PropertyRegistration",
	ReferralFee: "ReferralFee",
	OtherAncillaryCost: "OtherAncillaryCost",
	AgencyFeeSelling: "AgencyFeeSelling",
	OtherAncillaryCostSelling: "OtherAncillaryCostSelling",
	GeneralRenovationCost: "GeneralRenovationCost",
	KitchenCost: "KitchenCost",
	OtherRenovationCost: "OtherRenovationCost",
	HomeOwnersFee: "HomeOwnersFee",
	Utilities: "Utilities",
	PropertyTax: "PropertyTax",
	Internal: "Internal",
	HomeSpecialFee: "HomeSpecialFee",
	PropertyRelatedExpenses: "PropertyRelatedExpenses",
	PropertyValuation: "PropertyValuation",
	RecruitingExpenses: "RecruitingExpenses",
	OfficeExpenses: "OfficeExpenses",
	MarketingExpenses: "MarketingExpenses",
	EquipmentExpensesAndDA: "EquipmentExpensesAndDA",
	TechnologyAndAnalytics: "TechnologyAndAnalytics",
	TravelExpenses: "TravelExpenses",
	OtherAdministrativeCosts: "OtherAdministrativeCosts",
	ExternalLabourCosts: "ExternalLabourCosts",
	Training: "Training",
	TeamEvent: "TeamEvent",
	OtherLabourRelatedCosts: "OtherLabourRelatedCosts",
	OfficeRent: "OfficeRent",
	CarAndLeasingCosts: "CarAndLeasingCosts",
	LegalCosts: "LegalCosts",
	ConsultancyCosts: "ConsultancyCosts",
	AdvertisingCosts: "AdvertisingCosts",
	SplitInvoice: "SplitInvoice",
	CarRelatedCosts: "CarRelatedCosts",
	AuditAndTax: "AuditAndTax",
	Payroll: "Payroll",
	RepairAndMaintenance: "RepairAndMaintenance",
	RepairAndMaintenanceRecoverable: "RepairAndMaintenanceRecoverable",
	RentReduction: "RentReduction",
	DepositRefund: "DepositRefund",
	UtilitiesRefund: "UtilitiesRefund",
	UtilitiesAdditionalPayment: "UtilitiesAdditionalPayment",
	RepairCosts: "RepairCosts",
	RentGuarantee: "RentGuarantee",
	Livings: "Livings",
	LivingsEquipment: "LivingsEquipment",
	LivingsCleaningCosts: "LivingsCleaningCosts",
	LivingsTelephoneCosts: "LivingsTelephoneCosts",
	LivingsUtilities: "LivingsUtilities",
	LivingsOther: "LivingsOther",
	NonRecsMaintenance: "NonRecsMaintenance",
	RenovationCostsEnergyEfficiency: "RenovationCostsEnergyEfficiency",
	RenovationCostsInteriorResidential: "RenovationCostsInteriorResidential",
	RenovationCostsInteriorCommercial: "RenovationCostsInteriorCommercial",
	RenovationCostsGeneralCapex: "RenovationCostsGeneralCapex",
	RenovationCostsExpansion: "RenovationCostsExpansion",
	OperatingPartnerFee: "OperatingPartnerFee",
	TechnicalDD: "TechnicalDD",
	LegalDD: "LegalDD",
	OperationalRecs: "OperationalRecs",
	ExternalServiceProvider: "ExternalServiceProvider",
	ExternalServiceProviderReneo: "ExternalServiceProviderReneo",
	EnergyConsultancyCosts: "EnergyConsultancyCosts",
	PlanningCosts: "PlanningCosts"
};
//#endregion
//#region src/listing-persister/gen/models/ViewRenovationEstate.ts
const ConstructionPlansState = {
	New: "New",
	Draft: "Draft",
	Review: "Review",
	Approved: "Approved",
	Rejected: "Rejected",
	Completed: "Completed"
};
//#endregion
//#region src/listing-persister/gen/models/auditModels/GetNthChangesForColumns.ts
const AuditLogsOperation = { c: "c" };
const AuditLogsOperation2 = { u: "u" };
const AuditLogsOperation3 = { d: "d" };
const AuditLogsOperation4 = { r: "r" };
const AuditLogsOperation5 = { t: "t" };
const AuditLogsOperation6 = { m: "m" };
const AuditLogsOperation7 = { c: "c" };
const AuditLogsOperation8 = { u: "u" };
const AuditLogsOperation9 = { d: "d" };
const AuditLogsOperation10 = { r: "r" };
const AuditLogsOperation11 = { t: "t" };
const AuditLogsOperation12 = { m: "m" };
//#endregion
//#region src/listing-persister/gen/models/auditModels/GetNthChangesForRows.ts
const AuditLogsOperation13 = { c: "c" };
const AuditLogsOperation14 = { u: "u" };
const AuditLogsOperation15 = { d: "d" };
const AuditLogsOperation16 = { r: "r" };
const AuditLogsOperation17 = { t: "t" };
const AuditLogsOperation18 = { m: "m" };
const AuditLogsOperation19 = { c: "c" };
const AuditLogsOperation20 = { u: "u" };
const AuditLogsOperation21 = { d: "d" };
const AuditLogsOperation22 = { r: "r" };
const AuditLogsOperation23 = { t: "t" };
const AuditLogsOperation24 = { m: "m" };
//#endregion
//#region src/listing-persister/gen/models/auditModels/GetNthChangesForTable.ts
const AuditLogsOperation25 = { c: "c" };
const AuditLogsOperation26 = { u: "u" };
const AuditLogsOperation27 = { d: "d" };
const AuditLogsOperation28 = { r: "r" };
const AuditLogsOperation29 = { t: "t" };
const AuditLogsOperation30 = { m: "m" };
const AuditLogsOperation31 = { c: "c" };
const AuditLogsOperation32 = { u: "u" };
const AuditLogsOperation33 = { d: "d" };
const AuditLogsOperation34 = { r: "r" };
const AuditLogsOperation35 = { t: "t" };
const AuditLogsOperation36 = { m: "m" };
//#endregion
//#region src/listing-persister/gen/models/estateModels/FindRenovationEstates.ts
const FindRenovationEstatesQueryParamsOrder = { asc: "asc" };
const FindRenovationEstatesQueryParamsOrder2 = { desc: "desc" };
const FindRenovationEstatesQueryParamsProcessState = {
	Identified: "Identified",
	Measured: "Measured",
	Modelled: "Modelled",
	Briefed: "Briefed",
	Planned: "Planned",
	Prepared: "Prepared",
	CapturedWithContractor: "CapturedWithContractor",
	RenovationStarted: "RenovationStarted",
	InRenovation: "InRenovation",
	OnHold: "OnHold",
	InWarranty: "InWarranty",
	CompletionRequested: "CompletionRequested",
	Completed: "Completed",
	DefectsPending: "DefectsPending",
	Cancelled: "Cancelled"
};
//#endregion
//#region src/listing-persister/gen/models/invoiceModels/FindInvoices.ts
const FindInvoicesQueryParamsOrder = { ASC: "ASC" };
const FindInvoicesQueryParamsOrder2 = { DESC: "DESC" };
const FindInvoicesQueryParamsCostType = {
	Notary: "Notary",
	LandTransferTaxes: "LandTransferTaxes",
	AgencyFee: "AgencyFee",
	PropertyRegistration: "PropertyRegistration",
	ReferralFee: "ReferralFee",
	OtherAncillaryCost: "OtherAncillaryCost",
	AgencyFeeSelling: "AgencyFeeSelling",
	OtherAncillaryCostSelling: "OtherAncillaryCostSelling",
	GeneralRenovationCost: "GeneralRenovationCost",
	KitchenCost: "KitchenCost",
	OtherRenovationCost: "OtherRenovationCost",
	HomeOwnersFee: "HomeOwnersFee",
	Utilities: "Utilities",
	PropertyTax: "PropertyTax",
	Internal: "Internal",
	HomeSpecialFee: "HomeSpecialFee",
	PropertyRelatedExpenses: "PropertyRelatedExpenses",
	PropertyValuation: "PropertyValuation",
	RecruitingExpenses: "RecruitingExpenses",
	OfficeExpenses: "OfficeExpenses",
	MarketingExpenses: "MarketingExpenses",
	EquipmentExpensesAndDA: "EquipmentExpensesAndDA",
	TechnologyAndAnalytics: "TechnologyAndAnalytics",
	TravelExpenses: "TravelExpenses",
	OtherAdministrativeCosts: "OtherAdministrativeCosts",
	ExternalLabourCosts: "ExternalLabourCosts",
	Training: "Training",
	TeamEvent: "TeamEvent",
	OtherLabourRelatedCosts: "OtherLabourRelatedCosts",
	OfficeRent: "OfficeRent",
	CarAndLeasingCosts: "CarAndLeasingCosts",
	LegalCosts: "LegalCosts",
	ConsultancyCosts: "ConsultancyCosts",
	AdvertisingCosts: "AdvertisingCosts",
	SplitInvoice: "SplitInvoice",
	CarRelatedCosts: "CarRelatedCosts",
	AuditAndTax: "AuditAndTax",
	Payroll: "Payroll",
	RepairAndMaintenance: "RepairAndMaintenance",
	RepairAndMaintenanceRecoverable: "RepairAndMaintenanceRecoverable",
	RentReduction: "RentReduction",
	DepositRefund: "DepositRefund",
	UtilitiesRefund: "UtilitiesRefund",
	UtilitiesAdditionalPayment: "UtilitiesAdditionalPayment",
	RepairCosts: "RepairCosts",
	RentGuarantee: "RentGuarantee",
	Livings: "Livings",
	LivingsEquipment: "LivingsEquipment",
	LivingsCleaningCosts: "LivingsCleaningCosts",
	LivingsTelephoneCosts: "LivingsTelephoneCosts",
	LivingsUtilities: "LivingsUtilities",
	LivingsOther: "LivingsOther",
	NonRecsMaintenance: "NonRecsMaintenance",
	RenovationCostsEnergyEfficiency: "RenovationCostsEnergyEfficiency",
	RenovationCostsInteriorResidential: "RenovationCostsInteriorResidential",
	RenovationCostsInteriorCommercial: "RenovationCostsInteriorCommercial",
	RenovationCostsGeneralCapex: "RenovationCostsGeneralCapex",
	RenovationCostsExpansion: "RenovationCostsExpansion",
	OperatingPartnerFee: "OperatingPartnerFee",
	TechnicalDD: "TechnicalDD",
	LegalDD: "LegalDD",
	OperationalRecs: "OperationalRecs",
	ExternalServiceProvider: "ExternalServiceProvider",
	ExternalServiceProviderReneo: "ExternalServiceProviderReneo",
	EnergyConsultancyCosts: "EnergyConsultancyCosts",
	PlanningCosts: "PlanningCosts"
};
const FindInvoicesQueryParamsCostType2 = {
	Notary: "Notary",
	LandTransferTaxes: "LandTransferTaxes",
	AgencyFee: "AgencyFee",
	PropertyRegistration: "PropertyRegistration",
	ReferralFee: "ReferralFee",
	OtherAncillaryCost: "OtherAncillaryCost",
	AgencyFeeSelling: "AgencyFeeSelling",
	OtherAncillaryCostSelling: "OtherAncillaryCostSelling",
	GeneralRenovationCost: "GeneralRenovationCost",
	KitchenCost: "KitchenCost",
	OtherRenovationCost: "OtherRenovationCost",
	HomeOwnersFee: "HomeOwnersFee",
	Utilities: "Utilities",
	PropertyTax: "PropertyTax",
	Internal: "Internal",
	HomeSpecialFee: "HomeSpecialFee",
	PropertyRelatedExpenses: "PropertyRelatedExpenses",
	PropertyValuation: "PropertyValuation",
	RecruitingExpenses: "RecruitingExpenses",
	OfficeExpenses: "OfficeExpenses",
	MarketingExpenses: "MarketingExpenses",
	EquipmentExpensesAndDA: "EquipmentExpensesAndDA",
	TechnologyAndAnalytics: "TechnologyAndAnalytics",
	TravelExpenses: "TravelExpenses",
	OtherAdministrativeCosts: "OtherAdministrativeCosts",
	ExternalLabourCosts: "ExternalLabourCosts",
	Training: "Training",
	TeamEvent: "TeamEvent",
	OtherLabourRelatedCosts: "OtherLabourRelatedCosts",
	OfficeRent: "OfficeRent",
	CarAndLeasingCosts: "CarAndLeasingCosts",
	LegalCosts: "LegalCosts",
	ConsultancyCosts: "ConsultancyCosts",
	AdvertisingCosts: "AdvertisingCosts",
	SplitInvoice: "SplitInvoice",
	CarRelatedCosts: "CarRelatedCosts",
	AuditAndTax: "AuditAndTax",
	Payroll: "Payroll",
	RepairAndMaintenance: "RepairAndMaintenance",
	RepairAndMaintenanceRecoverable: "RepairAndMaintenanceRecoverable",
	RentReduction: "RentReduction",
	DepositRefund: "DepositRefund",
	UtilitiesRefund: "UtilitiesRefund",
	UtilitiesAdditionalPayment: "UtilitiesAdditionalPayment",
	RepairCosts: "RepairCosts",
	RentGuarantee: "RentGuarantee",
	Livings: "Livings",
	LivingsEquipment: "LivingsEquipment",
	LivingsCleaningCosts: "LivingsCleaningCosts",
	LivingsTelephoneCosts: "LivingsTelephoneCosts",
	LivingsUtilities: "LivingsUtilities",
	LivingsOther: "LivingsOther",
	NonRecsMaintenance: "NonRecsMaintenance",
	RenovationCostsEnergyEfficiency: "RenovationCostsEnergyEfficiency",
	RenovationCostsInteriorResidential: "RenovationCostsInteriorResidential",
	RenovationCostsInteriorCommercial: "RenovationCostsInteriorCommercial",
	RenovationCostsGeneralCapex: "RenovationCostsGeneralCapex",
	RenovationCostsExpansion: "RenovationCostsExpansion",
	OperatingPartnerFee: "OperatingPartnerFee",
	TechnicalDD: "TechnicalDD",
	LegalDD: "LegalDD",
	OperationalRecs: "OperationalRecs",
	ExternalServiceProvider: "ExternalServiceProvider",
	ExternalServiceProviderReneo: "ExternalServiceProviderReneo",
	EnergyConsultancyCosts: "EnergyConsultancyCosts",
	PlanningCosts: "PlanningCosts"
};
const FindInvoicesQueryParamsState = {
	New: "New",
	Assigned: "Assigned",
	WaitingForAuthorization: "WaitingForAuthorization",
	ManualReview: "ManualReview",
	Approved: "Approved",
	ReadyForPayment: "ReadyForPayment",
	FailedToExport: "FailedToExport",
	Paid: "Paid",
	PartiallyPaid: "PartiallyPaid",
	ManuallyPaid: "ManuallyPaid",
	ReadyForDrawdown: "ReadyForDrawdown",
	DrawdownCompleted: "DrawdownCompleted",
	InDispute: "InDispute",
	Rejected: "Rejected",
	Reimbursed: "Reimbursed",
	Duplicated: "Duplicated",
	ReadyForBooking: "ReadyForBooking",
	Authorized: "Authorized",
	WaitingForDrawdown: "WaitingForDrawdown",
	WaitingForExternalReview: "WaitingForExternalReview"
};
const FindInvoicesQueryParamsState2 = {
	New: "New",
	Assigned: "Assigned",
	WaitingForAuthorization: "WaitingForAuthorization",
	ManualReview: "ManualReview",
	Approved: "Approved",
	ReadyForPayment: "ReadyForPayment",
	FailedToExport: "FailedToExport",
	Paid: "Paid",
	PartiallyPaid: "PartiallyPaid",
	ManuallyPaid: "ManuallyPaid",
	ReadyForDrawdown: "ReadyForDrawdown",
	DrawdownCompleted: "DrawdownCompleted",
	InDispute: "InDispute",
	Rejected: "Rejected",
	Reimbursed: "Reimbursed",
	Duplicated: "Duplicated",
	ReadyForBooking: "ReadyForBooking",
	Authorized: "Authorized",
	WaitingForDrawdown: "WaitingForDrawdown",
	WaitingForExternalReview: "WaitingForExternalReview"
};
const FindInvoicesQueryParamsOmittedInvoiceState = {
	New: "New",
	Assigned: "Assigned",
	WaitingForAuthorization: "WaitingForAuthorization",
	ManualReview: "ManualReview",
	Approved: "Approved",
	ReadyForPayment: "ReadyForPayment",
	FailedToExport: "FailedToExport",
	Paid: "Paid",
	PartiallyPaid: "PartiallyPaid",
	ManuallyPaid: "ManuallyPaid",
	ReadyForDrawdown: "ReadyForDrawdown",
	DrawdownCompleted: "DrawdownCompleted",
	InDispute: "InDispute",
	Rejected: "Rejected",
	Reimbursed: "Reimbursed",
	Duplicated: "Duplicated",
	ReadyForBooking: "ReadyForBooking",
	Authorized: "Authorized",
	WaitingForDrawdown: "WaitingForDrawdown",
	WaitingForExternalReview: "WaitingForExternalReview"
};
const FindInvoicesQueryParamsOmittedInvoiceType = {
	Normal: "Normal",
	PaymentReminder: "PaymentReminder",
	CreditNote: "CreditNote",
	RenovationGuarantee: "RenovationGuarantee",
	RecurrentPayment: "RecurrentPayment",
	MasterTemplate: "MasterTemplate",
	Other: "Other"
};
const FindInvoicesQueryParamsOmittedCostType = {
	Notary: "Notary",
	LandTransferTaxes: "LandTransferTaxes",
	AgencyFee: "AgencyFee",
	PropertyRegistration: "PropertyRegistration",
	ReferralFee: "ReferralFee",
	OtherAncillaryCost: "OtherAncillaryCost",
	AgencyFeeSelling: "AgencyFeeSelling",
	OtherAncillaryCostSelling: "OtherAncillaryCostSelling",
	GeneralRenovationCost: "GeneralRenovationCost",
	KitchenCost: "KitchenCost",
	OtherRenovationCost: "OtherRenovationCost",
	HomeOwnersFee: "HomeOwnersFee",
	Utilities: "Utilities",
	PropertyTax: "PropertyTax",
	Internal: "Internal",
	HomeSpecialFee: "HomeSpecialFee",
	PropertyRelatedExpenses: "PropertyRelatedExpenses",
	PropertyValuation: "PropertyValuation",
	RecruitingExpenses: "RecruitingExpenses",
	OfficeExpenses: "OfficeExpenses",
	MarketingExpenses: "MarketingExpenses",
	EquipmentExpensesAndDA: "EquipmentExpensesAndDA",
	TechnologyAndAnalytics: "TechnologyAndAnalytics",
	TravelExpenses: "TravelExpenses",
	OtherAdministrativeCosts: "OtherAdministrativeCosts",
	ExternalLabourCosts: "ExternalLabourCosts",
	Training: "Training",
	TeamEvent: "TeamEvent",
	OtherLabourRelatedCosts: "OtherLabourRelatedCosts",
	OfficeRent: "OfficeRent",
	CarAndLeasingCosts: "CarAndLeasingCosts",
	LegalCosts: "LegalCosts",
	ConsultancyCosts: "ConsultancyCosts",
	AdvertisingCosts: "AdvertisingCosts",
	SplitInvoice: "SplitInvoice",
	CarRelatedCosts: "CarRelatedCosts",
	AuditAndTax: "AuditAndTax",
	Payroll: "Payroll",
	RepairAndMaintenance: "RepairAndMaintenance",
	RepairAndMaintenanceRecoverable: "RepairAndMaintenanceRecoverable",
	RentReduction: "RentReduction",
	DepositRefund: "DepositRefund",
	UtilitiesRefund: "UtilitiesRefund",
	UtilitiesAdditionalPayment: "UtilitiesAdditionalPayment",
	RepairCosts: "RepairCosts",
	RentGuarantee: "RentGuarantee",
	Livings: "Livings",
	LivingsEquipment: "LivingsEquipment",
	LivingsCleaningCosts: "LivingsCleaningCosts",
	LivingsTelephoneCosts: "LivingsTelephoneCosts",
	LivingsUtilities: "LivingsUtilities",
	LivingsOther: "LivingsOther",
	NonRecsMaintenance: "NonRecsMaintenance",
	RenovationCostsEnergyEfficiency: "RenovationCostsEnergyEfficiency",
	RenovationCostsInteriorResidential: "RenovationCostsInteriorResidential",
	RenovationCostsInteriorCommercial: "RenovationCostsInteriorCommercial",
	RenovationCostsGeneralCapex: "RenovationCostsGeneralCapex",
	RenovationCostsExpansion: "RenovationCostsExpansion",
	OperatingPartnerFee: "OperatingPartnerFee",
	TechnicalDD: "TechnicalDD",
	LegalDD: "LegalDD",
	OperationalRecs: "OperationalRecs",
	ExternalServiceProvider: "ExternalServiceProvider",
	ExternalServiceProviderReneo: "ExternalServiceProviderReneo",
	EnergyConsultancyCosts: "EnergyConsultancyCosts",
	PlanningCosts: "PlanningCosts"
};
const FindInvoicesQueryParamsInvoiceType = {
	Normal: "Normal",
	PaymentReminder: "PaymentReminder",
	CreditNote: "CreditNote",
	RenovationGuarantee: "RenovationGuarantee",
	RecurrentPayment: "RecurrentPayment",
	MasterTemplate: "MasterTemplate",
	Other: "Other"
};
const FindInvoicesQueryParamsInvoiceType2 = {
	Normal: "Normal",
	PaymentReminder: "PaymentReminder",
	CreditNote: "CreditNote",
	RenovationGuarantee: "RenovationGuarantee",
	RecurrentPayment: "RecurrentPayment",
	MasterTemplate: "MasterTemplate",
	Other: "Other"
};
const FindInvoicesQueryParamsFetchType = {
	All: "All",
	ExportableInvoicesNetSuite: "ExportableInvoicesNetSuite",
	ExportableInvoices: "ExportableInvoices",
	ExportableSevInvoices: "ExportableSevInvoices",
	TransferRecurrentPayments: "TransferRecurrentPayments",
	ExternalAppInvoicesForExport: "ExternalAppInvoicesForExport"
};
//#endregion
//#region src/listing-persister/gen/models/typesenseModels/BulkSyncCollection.ts
const BulkSyncCollectionPathParamsCollectionName = { searchable: "searchable" };
//#endregion
//#region src/listing-persister/gen/models/typesenseModels/SaveRecentlyVisitedPages.ts
const PagesType = {
	estate: "estate",
	mfh: "mfh",
	invoice: "invoice",
	general: "general"
};
//#endregion
//#region src/listing-persister/gen/models/userConfirmationModels/SettleUserConfirmation.ts
const SettleUserConfirmationMutationRequestStatus = {
	CREATED: "CREATED",
	APPROVED: "APPROVED",
	TIMEOUT: "TIMEOUT",
	ERROR: "ERROR",
	REJECTED: "REJECTED"
};
//#endregion
//#region src/listing-persister/gen/clients/axios.ts
var axios_exports = /* @__PURE__ */ __exportAll({
	bulkSyncCollection: () => bulkSyncCollection,
	cleanupCdcOutboxTable: () => cleanupCdcOutboxTable,
	fetchUserConfirmations: () => fetchUserConfirmations,
	findInvoices: () => findInvoices,
	findRenovationEstates: () => findRenovationEstates,
	getAuditLogDiff: () => getAuditLogDiff,
	getDatabaseTablesAndColumns: () => getDatabaseTablesAndColumns,
	getHistoryAuditLogsForAggregate: () => getHistoryAuditLogsForAggregate,
	getLatestChangesForColumns: () => getLatestChangesForColumns,
	getNthChangesForColumns: () => getNthChangesForColumns,
	getNthChangesForRows: () => getNthChangesForRows,
	getNthChangesForTable: () => getNthChangesForTable,
	getStatus: () => getStatus,
	operations: () => operations,
	resetCdcOutboxFailedEvents: () => resetCdcOutboxFailedEvents,
	saveRecentlyVisitedPages: () => saveRecentlyVisitedPages,
	settleUserConfirmation: () => settleUserConfirmation,
	triggerSnapshot: () => triggerSnapshot
});
/**
* @description Returns known available tables and columns from database for audit log
* @link /database-tables-and-columns
*/
async function getDatabaseTablesAndColumns(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/database-tables-and-columns`,
		params,
		...options
	})).data;
}
/**
* @description Return diff for a specific auditLog entry
* @link /audit-log/:auditLogId/diff
*/
async function getAuditLogDiff({ auditLogId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/audit-log/${auditLogId}/diff`,
		...options
	})).data;
}
/**
* @description Receives audit-log entries by aggregate-root
* @link /audit-as-history
*/
async function getHistoryAuditLogsForAggregate(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/audit-as-history`,
		params,
		...options
	})).data;
}
/**
* @description Provides the last change for a column of a specific row in a table
* @link /changes/latest/databases/:database/tables/:table/rows/:pk/columns/:columns/latest
*/
async function getLatestChangesForColumns({ database, table, pk, columns }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/changes/latest/databases/${database}/tables/${table}/rows/${pk}/columns/${columns}/latest`,
		...options
	})).data;
}
/**
* @description Provides up to n changes for selected column(s) of a specific row in a table.
* @link /changes/history/databases/:database/tables/:table/rows/:pk/columns/:columns
*/
async function getNthChangesForColumns({ database, table, pk, columns }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/changes/history/databases/${database}/tables/${table}/rows/${pk}/columns/${columns}`,
		params,
		...options
	})).data;
}
/**
* @description Provides up to n changes for a specific row in a table.
* @link /changes/history/databases/:database/tables/:table/rows/:pk
*/
async function getNthChangesForRows({ database, table, pk }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/changes/history/databases/${database}/tables/${table}/rows/${pk}`,
		params,
		...options
	})).data;
}
/**
* @description Provides up to n changes for a table.
* @link /changes/history/databases/:database/tables/:table
*/
async function getNthChangesForTable({ database, table }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/changes/history/databases/${database}/tables/${table}`,
		params,
		...options
	})).data;
}
/**
* @description Sync collections on bulk to typesense
* @link /bulk-sync-collection/:collectionName
*/
async function bulkSyncCollection({ collectionName }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/bulk-sync-collection/${collectionName}`,
		...options
	})).data;
}
/**
* @description Save recently visited pages
* @link /recent-visited-pages
*/
async function saveRecentlyVisitedPages(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/recent-visited-pages`,
		data,
		...options
	})).data;
}
/**
* @description Renovation estates overview route
* @link /renovation/estates
*/
async function findRenovationEstates(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/renovation/estates`,
		params,
		...options
	})).data;
}
/**
* @description Gets status of all major (sub) components
* @link /status
*/
async function getStatus(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/status`,
		...options
	})).data;
}
/**
* @description Invoices overview route
* @link /invoices
*/
async function findInvoices(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/invoices`,
		params,
		...options
	})).data;
}
/**
* @description Triggers a cdc-snapshot for all configured tables at the given target-database
* @link /maintenance/trigger-cdc-snapshot
*/
async function triggerSnapshot(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/maintenance/trigger-cdc-snapshot`,
		data,
		...options
	})).data;
}
/**
* @description Cleanup processed outbox events and perform VACUUM ANALYZE
* @link /maintenance/cleanup-cdc-outbox-table
*/
async function cleanupCdcOutboxTable(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/maintenance/cleanup-cdc-outbox-table`,
		data,
		...options
	})).data;
}
/**
* @description Reset failed cdc outbox events
* @link /maintenance/reset-failed-cdc-outbox-events
*/
async function resetCdcOutboxFailedEvents(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/maintenance/reset-failed-cdc-outbox-events`,
		data,
		...options
	})).data;
}
/**
* @description Settles a user-confirmation (either approved or rejected)
* @link /user-confirmations/:id
*/
async function settleUserConfirmation({ id }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/user-confirmations/${id}`,
		data,
		...options
	})).data;
}
/**
* @description Fetches user-confirmations, which are not yet approved/rejected
* @link /user-confirmations
*/
async function fetchUserConfirmations(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/user-confirmations`,
		...options
	})).data;
}
const operations = {
	getDatabaseTablesAndColumns: {
		path: "/database-tables-and-columns",
		method: "get"
	},
	getAuditLogDiff: {
		path: "/audit-log/:auditLogId/diff",
		method: "get"
	},
	getHistoryAuditLogsForAggregate: {
		path: "/audit-as-history",
		method: "get"
	},
	getLatestChangesForColumns: {
		path: "/changes/latest/databases/:database/tables/:table/rows/:pk/columns/:columns/latest",
		method: "get"
	},
	getNthChangesForColumns: {
		path: "/changes/history/databases/:database/tables/:table/rows/:pk/columns/:columns",
		method: "get"
	},
	getNthChangesForRows: {
		path: "/changes/history/databases/:database/tables/:table/rows/:pk",
		method: "get"
	},
	getNthChangesForTable: {
		path: "/changes/history/databases/:database/tables/:table",
		method: "get"
	},
	bulkSyncCollection: {
		path: "/bulk-sync-collection/:collectionName",
		method: "get"
	},
	saveRecentlyVisitedPages: {
		path: "/recent-visited-pages",
		method: "post"
	},
	findRenovationEstates: {
		path: "/renovation/estates",
		method: "get"
	},
	getStatus: {
		path: "/status",
		method: "get"
	},
	findInvoices: {
		path: "/invoices",
		method: "get"
	},
	triggerSnapshot: {
		path: "/maintenance/trigger-cdc-snapshot",
		method: "post"
	},
	cleanupCDCOutboxTable: {
		path: "/maintenance/cleanup-cdc-outbox-table",
		method: "post"
	},
	resetCDCOutboxFailedEvents: {
		path: "/maintenance/reset-failed-cdc-outbox-events",
		method: "post"
	},
	settleUserConfirmation: {
		path: "/user-confirmations/:id",
		method: "post"
	},
	fetchUserConfirmations: {
		path: "/user-confirmations",
		method: "get"
	}
};
//#endregion
//#region src/listing-persister/gen/clients/axios-class-client.ts
var ListingPersisterSdk = class {
	client;
	constructor(client) {
		this.client = client;
	}
	async axiosClient(config) {
		return this.client.request({ ...config }).catch((e) => {
			throw e;
		});
	}
	/**
	* @description Returns known available tables and columns from database for audit log
	* @link /database-tables-and-columns
	*/
	async getDatabaseTablesAndColumns(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/database-tables-and-columns`,
			params,
			...options
		})).data;
	}
	/**
	* @description Return diff for a specific auditLog entry
	* @link /audit-log/:auditLogId/diff
	*/
	async getAuditLogDiff({ auditLogId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/audit-log/${auditLogId}/diff`,
			...options
		})).data;
	}
	/**
	* @description Receives audit-log entries by aggregate-root
	* @link /audit-as-history
	*/
	async getHistoryAuditLogsForAggregate(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/audit-as-history`,
			params,
			...options
		})).data;
	}
	/**
	* @description Provides the last change for a column of a specific row in a table
	* @link /changes/latest/databases/:database/tables/:table/rows/:pk/columns/:columns/latest
	*/
	async getLatestChangesForColumns({ database, table, pk, columns }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/changes/latest/databases/${database}/tables/${table}/rows/${pk}/columns/${columns}/latest`,
			...options
		})).data;
	}
	/**
	* @description Provides up to n changes for selected column(s) of a specific row in a table.
	* @link /changes/history/databases/:database/tables/:table/rows/:pk/columns/:columns
	*/
	async getNthChangesForColumns({ database, table, pk, columns }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/changes/history/databases/${database}/tables/${table}/rows/${pk}/columns/${columns}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Provides up to n changes for a specific row in a table.
	* @link /changes/history/databases/:database/tables/:table/rows/:pk
	*/
	async getNthChangesForRows({ database, table, pk }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/changes/history/databases/${database}/tables/${table}/rows/${pk}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Provides up to n changes for a table.
	* @link /changes/history/databases/:database/tables/:table
	*/
	async getNthChangesForTable({ database, table }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/changes/history/databases/${database}/tables/${table}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Sync collections on bulk to typesense
	* @link /bulk-sync-collection/:collectionName
	*/
	async bulkSyncCollection({ collectionName }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/bulk-sync-collection/${collectionName}`,
			...options
		})).data;
	}
	/**
	* @description Save recently visited pages
	* @link /recent-visited-pages
	*/
	async saveRecentlyVisitedPages(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/recent-visited-pages`,
			data,
			...options
		})).data;
	}
	/**
	* @description Renovation estates overview route
	* @link /renovation/estates
	*/
	async findRenovationEstates(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/renovation/estates`,
			params,
			...options
		})).data;
	}
	/**
	* @description Gets status of all major (sub) components
	* @link /status
	*/
	async getStatus(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/status`,
			...options
		})).data;
	}
	/**
	* @description Invoices overview route
	* @link /invoices
	*/
	async findInvoices(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/invoices`,
			params,
			...options
		})).data;
	}
	/**
	* @description Triggers a cdc-snapshot for all configured tables at the given target-database
	* @link /maintenance/trigger-cdc-snapshot
	*/
	async triggerSnapshot(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/maintenance/trigger-cdc-snapshot`,
			data,
			...options
		})).data;
	}
	/**
	* @description Cleanup processed outbox events and perform VACUUM ANALYZE
	* @link /maintenance/cleanup-cdc-outbox-table
	*/
	async cleanupCdcOutboxTable(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/maintenance/cleanup-cdc-outbox-table`,
			data,
			...options
		})).data;
	}
	/**
	* @description Reset failed cdc outbox events
	* @link /maintenance/reset-failed-cdc-outbox-events
	*/
	async resetCdcOutboxFailedEvents(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/maintenance/reset-failed-cdc-outbox-events`,
			data,
			...options
		})).data;
	}
	/**
	* @description Settles a user-confirmation (either approved or rejected)
	* @link /user-confirmations/:id
	*/
	async settleUserConfirmation({ id }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/user-confirmations/${id}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Fetches user-confirmations, which are not yet approved/rejected
	* @link /user-confirmations
	*/
	async fetchUserConfirmations(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/user-confirmations`,
			...options
		})).data;
	}
};
//#endregion
export { AuditLogsOperation, AuditLogsOperation10, AuditLogsOperation11, AuditLogsOperation12, AuditLogsOperation13, AuditLogsOperation14, AuditLogsOperation15, AuditLogsOperation16, AuditLogsOperation17, AuditLogsOperation18, AuditLogsOperation19, AuditLogsOperation2, AuditLogsOperation20, AuditLogsOperation21, AuditLogsOperation22, AuditLogsOperation23, AuditLogsOperation24, AuditLogsOperation25, AuditLogsOperation26, AuditLogsOperation27, AuditLogsOperation28, AuditLogsOperation29, AuditLogsOperation3, AuditLogsOperation30, AuditLogsOperation31, AuditLogsOperation32, AuditLogsOperation33, AuditLogsOperation34, AuditLogsOperation35, AuditLogsOperation36, AuditLogsOperation4, AuditLogsOperation5, AuditLogsOperation6, AuditLogsOperation7, AuditLogsOperation8, AuditLogsOperation9, BulkSyncCollectionPathParamsCollectionName, ConstructionPlansState, FindInvoicesQueryParamsCostType, FindInvoicesQueryParamsCostType2, FindInvoicesQueryParamsFetchType, FindInvoicesQueryParamsInvoiceType, FindInvoicesQueryParamsInvoiceType2, FindInvoicesQueryParamsOmittedCostType, FindInvoicesQueryParamsOmittedInvoiceState, FindInvoicesQueryParamsOmittedInvoiceType, FindInvoicesQueryParamsOrder, FindInvoicesQueryParamsOrder2, FindInvoicesQueryParamsState, FindInvoicesQueryParamsState2, FindRenovationEstatesQueryParamsOrder, FindRenovationEstatesQueryParamsOrder2, FindRenovationEstatesQueryParamsProcessState, ListingPersisterSdk, PagesType, SettleUserConfirmationMutationRequestStatus, ViewInvoicesCostType, ViewInvoicesInvoiceType, ViewInvoicesState, initHTTPClient as initListingPersisterHTTPClient, axios_exports as listingPersisterApi };
